import { Box, CircularProgress } from '@mui/material'
import { Button } from 'Common/Supplyvue-ui'
import { Edit, Check } from '@mui/icons-material'
import { CreatePlanDataTypes } from '../OperationalPlanner.types'
import { canSelectSourceSites, isFormValid } from './utils/planHelpers'

interface PlanActionButtonsProps {
  // Data
  createPlanDataObject: CreatePlanDataTypes

  // Loading states
  isPlanCreating: boolean
  isRunPlan: boolean
  isEditSettings: boolean

  // Action handlers
  onSelectSourceSites: () => void
  onRunPlan: () => void
  onEditSettings: () => void
  onUpdateConstrainingHorizons: () => void
}

export const PlanActionButtons = ({
  createPlanDataObject,
  isPlanCreating,
  isRunPlan,
  isEditSettings,
  onSelectSourceSites,
  onRunPlan,
  onEditSettings,
  onUpdateConstrainingHorizons,
}: PlanActionButtonsProps) => {
  const hasSourceSites = createPlanDataObject.sourceSites.length > 0
  const canSelectSites = canSelectSourceSites(createPlanDataObject)
  const canSubmitPlan = isFormValid(createPlanDataObject)
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'space-around',
        marginTop: '20px',
        marginLeft: '70px',
      }}
    >
      <Box display="flex" flexDirection="column">
        <Box marginBottom={2}>
          <Button
            onClick={onSelectSourceSites}
            sx={{
              marginLeft: '20px',
              minWidth: '105px',
            }}
            label="Select source sites"
            disabled={!canSelectSites || isPlanCreating}
            variant="contained"
          >
            {hasSourceSites && (
              <Box marginRight={1} display="flex">
                <Check />
              </Box>
            )}
            {'Select source sites'}
          </Button>
        </Box>

        {/* {hasSourceSites && (
          <Box marginBottom={2}>
            <Button
              onClick={onUpdateConstrainingHorizons}
              sx={{
                marginLeft: '20px',
                minWidth: '105px',
              }}
              label="Update constraining horizons"
              disabled={isPlanCreating}
              variant="outlined"
            >
              Update constraining horizons
            </Button>
          </Box>
        )} */}

        {hasSourceSites && (
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Button
              onClick={onRunPlan}
              sx={{
                marginLeft: '20px',
                minWidth: '105px',
              }}
              label="Create plan"
              disabled={!canSubmitPlan || isPlanCreating}
              variant="contained"
            >
              {isRunPlan && (
                <CircularProgress
                  color="inherit"
                  size={16}
                  sx={{
                    marginRight: '8px',
                  }}
                />
              )}
              Run plan
            </Button>
            <Box sx={{ marginRight: 5 }} />

            <Button
              onClick={onEditSettings}
              variant="outlined"
              disabled={isPlanCreating}
              startIcon={
                isEditSettings ? (
                  <CircularProgress
                    size={16}
                    color="inherit"
                    sx={{
                      marginRight: '8px',
                    }}
                  />
                ) : (
                  <Edit />
                )
              }
            >
              Edit Settings (Optional)
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  )
}
